<template>
<div id="treatment-plan-objectives-v1-ghrw1u">
    <div id="treatment-plan-objectives-v1-ivetxd" class="mb-0 py-4" v-if="showType == 'form-builder'" :style="properties.style" style="font-size:14px">
      Treatment Plan Objectives
    </div>
    <div id="treatment-plan-objectives-v1-slmrab" v-if="showType == 'properties'">
      <treatment-plan-objectives-v1-properties id="treatment-plan-objectives-v1-r4tok9" :formId="formId"></treatment-plan-objectives-v1-properties>
    </div>
    <!-- <div id="treatment-plan-objectives-v1-uzue8a"
      class="mb-0"
      v-if="
        showType == 'form-submitter' ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :style="properties.style"
    > -->
    <div id="treatment-plan-objectives-v1-qp65hv" class="mb-0" v-if="showType == 'form-submitter' && page == currentPage" :style="properties.style" v-show="!computedHidden">
      <b-form-group id="treatment-plan-objectives-v1-hdsccn" label="Select Treatment Plan" style="max-width: 550px;font-size:14px;">
        <v-select id="treatment-plan-objectives-v1-86r3g1" style="font-size:14px;" v-model="masterTreatmentPlanDocument" :options="masterTreatmentPlanDocumentOptions"></v-select>
      </b-form-group>
      <div id="treatment-plan-objectives-v1-9jqg1q" v-if="masterTreatmentPlanForm && masterTreatmentPlanDocument">
        <div id="treatment-plan-objectives-v1-ys3gqh" class="d-flex justify-content-between align-items-center">
          <span id="treatment-plan-objectives-v1-g5kx2g" style="font-size:14px">Select Objectives</span>
          <!-- <b-button id="treatment-plan-objectives-v1-2543tt"
            size="sm"
            variant="primary"
            class="mr-2"
            @click="reloadObjectives"
            ><i id="treatment-plan-objectives-v1-i6xb4b" class="fa fa-sync-alt mr-2"></i> Reload Objectives</b-button
          > -->
        </div>
        <b-container id="treatment-plan-objectives-v1-t9k0hi" class="mt-2 border">
          <div v-for="(problem, problemIndex) in problemObjectives" :key="problemIndex" :id="'treatment-plan-objectives-v1-1kgce2-' + problemIndex">
            <b-row class="py-2 bg-extra-light-gray" style="font-size:13px;" :id="'treatment-plan-objectives-v1-v77dfb-' + problemIndex">
              <b-col :id="'treatment-plan-objectives-v1-u1qom4-' + problemIndex">
                <div :id="'treatment-plan-objectives-v1-wxcm8j-' + problemIndex"><strong :id="'treatment-plan-objectives-v1-aial96-' + problemIndex">Problem:</strong> {{ problem.problem }}</div>
                <div :id="'treatment-plan-objectives-v1-efkctg-' + problemIndex">
                  <strong :id="'treatment-plan-objectives-v1-n1pz51-' + problemIndex">Identified Problem:</strong>
                  {{ problem.identifiedProblem }}
                </div>
                <div :id="'treatment-plan-objectives-v1-uj4o91-' + problemIndex">
                  <strong :id="'treatment-plan-objectives-v1-tvmgem-' + problemIndex">Long-Term Goal:</strong> {{ problem.longTermGoal }}
                </div>
              </b-col>
            </b-row>
            <b-row class="border-bottom py-2" style="font-size:14px;" :id="'treatment-plan-objectives-v1-qw6yz4-' + problemIndex">
              <b-col :id="'treatment-plan-objectives-v1-j64a56-' + problemIndex">
                <strong :id="'treatment-plan-objectives-v1-zz6r63-' + problemIndex">Objective</strong>
              </b-col>
              <b-col :id="'treatment-plan-objectives-v1-2vjdmf-' + problemIndex">
                <strong :id="'treatment-plan-objectives-v1-01ju1u-' + problemIndex">Interventions</strong>
              </b-col>
              <b-col :id="'treatment-plan-objectives-v1-u59afq-' + problemIndex">
                <strong :id="'treatment-plan-objectives-v1-9meamr-' + problemIndex">Responsible Parties</strong>
              </b-col>
              <b-col :id="'treatment-plan-objectives-v1-1ivpjg-' + problemIndex">
                <strong :id="'treatment-plan-objectives-v1-exduqm-' + problemIndex">Details</strong>
              </b-col>
            </b-row>
            <b-row v-for="(objective, objectiveIndex) in problem.objectives" :key="objectiveIndex" class="border-bottom" style="font-size:12px;" :id="'treatment-plan-objectives-v1-2o8lkd-' + problemIndex + '-' + objectiveIndex">
              <b-col :id="'treatment-plan-objectives-v1-hub637-' + problemIndex + '-' + objectiveIndex">
                <b-form-checkbox size="sm" class="treament-objective-checkbox" v-model="objectiveSelected" :value="`problem_${problemIndex}_objective_${objectiveIndex}`" style="font-size:12px;" :id="'treatment-plan-objectives-v1-vfzneg-' + problemIndex + '-' + objectiveIndex"><span style="padding-top: 3px;" :id="'treatment-plan-objectives-v1-88pf0w-' + problemIndex + '-' + objectiveIndex">{{
                    objective.shortTermMeasurableObjective
                  }}</span></b-form-checkbox>
              </b-col>
              <b-col style="padding-top: 3px;" :id="'treatment-plan-objectives-v1-6i9265-' + problemIndex + '-' + objectiveIndex">
                <span :id="'treatment-plan-objectives-v1-vfc79p-' + problemIndex + '-' + objectiveIndex">{{ objective.interventions }}</span>
              </b-col>
              <b-col style="padding-top: 3px;" :id="'treatment-plan-objectives-v1-cv7j7w-' + problemIndex + '-' + objectiveIndex">
                <span :id="'treatment-plan-objectives-v1-57zcay-' + problemIndex + '-' + objectiveIndex">{{ objective.responsibleParties }}</span>
              </b-col>
              <b-col style="padding-top: 3px; padding-bottom: 3px;" :id="'treatment-plan-objectives-v1-otr96w-' + problemIndex + '-' + objectiveIndex">
                <b-textarea v-if="
                    objectiveSelected.includes(
                      `problem_${problemIndex}_objective_${objectiveIndex}`
                    )
                  " :value="
                    objectiveDetails[
                      `problem_${problemIndex}_objective_${objectiveIndex}`
                    ]
                      ? objectiveDetails[
                          `problem_${problemIndex}_objective_${objectiveIndex}`
                        ]
                      : ''
                  " @input="
                    newValue =>
                      setObjectiveDetails(
                        `problem_${problemIndex}_objective_${objectiveIndex}`,
                        newValue
                      )
                  " :id="'treatment-plan-objectives-v1-gb9u0d-' + problemIndex + '-' + objectiveIndex"></b-textarea>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>
    </div>
    <div id="treatment-plan-objectives-v1-0b0z2n" class="mb-0" v-if="showType == 'form-viewer'" :style="properties.style">
      <b-form-group id="treatment-plan-objectives-v1-6meicl" label="Treatment Plan">
        <span id="treatment-plan-objectives-v1-d7h6i8" style="font-size:14px">{{
          masterTreatmentPlanDocument.label
        }}</span>
      </b-form-group>
      <div id="treatment-plan-objectives-v1-r0wy2s" v-if="masterTreatmentPlanForm && masterTreatmentPlanDocument">
        <div id="treatment-plan-objectives-v1-2vaihq" class="d-flex justify-content-between align-items-center">
          <span id="treatment-plan-objectives-v1-5ymvxr" style="font-size:14px">Objectives</span>
          <!-- <b-button id="treatment-plan-objectives-v1-hc2423"
            size="sm"
            variant="primary"
            class="mr-2"
            @click="reloadObjectives"
            ><i id="treatment-plan-objectives-v1-o0fzz9" class="fa fa-sync-alt mr-2"></i> Reload Objectives</b-button
          > -->
        </div>
        <b-container id="treatment-plan-objectives-v1-600g5b" class="mt-2 border">
          <div v-for="(problem, problemIndex) in problemObjectives" :key="problemIndex" :id="'treatment-plan-objectives-v1-tlba29-' + problemIndex">
            <div v-if="
                problem.objectives.filter((objective, objectiveIndex) =>
                  objectiveSelected.includes(
                    `problem_${problemIndex}_objective_${objectiveIndex}`
                  )
                ).length > 0
              " :id="'treatment-plan-objectives-v1-1puezp-' + problemIndex">
              <b-row class="py-2 bg-extra-light-gray" style="font-size:13px;" :id="'treatment-plan-objectives-v1-b7nj59-' + problemIndex">
                <b-col :id="'treatment-plan-objectives-v1-ciegl3-' + problemIndex">
                  <div :id="'treatment-plan-objectives-v1-6vztby-' + problemIndex"><strong :id="'treatment-plan-objectives-v1-yt7ndp-' + problemIndex">Problem:</strong> {{ problem.problem }}</div>
                  <div :id="'treatment-plan-objectives-v1-whwcwd-' + problemIndex">
                    <strong :id="'treatment-plan-objectives-v1-cyosty-' + problemIndex">Identified Problem:</strong>
                    {{ problem.identifiedProblem }}
                  </div>
                  <div :id="'treatment-plan-objectives-v1-h98gmm-' + problemIndex">
                    <strong :id="'treatment-plan-objectives-v1-hrqwem-' + problemIndex">Long-Term Goal:</strong> {{ problem.longTermGoal }}
                  </div>
                </b-col>
              </b-row>
              <b-row class="border-bottom py-2" style="font-size:14px;" :id="'treatment-plan-objectives-v1-c24w1v-' + problemIndex">
                <b-col :id="'treatment-plan-objectives-v1-24k7c8-' + problemIndex">
                  <strong :id="'treatment-plan-objectives-v1-zns69s-' + problemIndex">Objective</strong>
                </b-col>
                <b-col :id="'treatment-plan-objectives-v1-zra1gm-' + problemIndex">
                  <strong :id="'treatment-plan-objectives-v1-x3vms9-' + problemIndex">Interventions</strong>
                </b-col>
                <b-col :id="'treatment-plan-objectives-v1-59yhi6-' + problemIndex">
                  <strong :id="'treatment-plan-objectives-v1-hf8x7g-' + problemIndex">Responsible Parties</strong>
                </b-col>
                <b-col :id="'treatment-plan-objectives-v1-5x724j-' + problemIndex">
                  <strong :id="'treatment-plan-objectives-v1-z3hl7i-' + problemIndex">Details</strong>
                </b-col>
              </b-row>
            </div>
            <div v-for="(objective, objectiveIndex) in problem.objectives" :key="objectiveIndex" :id="'treatment-plan-objectives-v1-spycs9-' + problemIndex + '-' + objectiveIndex">
              <b-row v-if="
                  objectiveSelected.includes(
                    `problem_${problemIndex}_objective_${objectiveIndex}`
                  )
                " class="py-2 border-bottom" style="font-size:12px;" :id="'treatment-plan-objectives-v1-ulge7o-' + problemIndex + '-' + objectiveIndex">
                <b-col :id="'treatment-plan-objectives-v1-ugphg6-' + problemIndex + '-' + objectiveIndex">
                  <b-icon-check-square-fill class="text-primary" v-if="
                      objectiveSelected.includes(
                        `problem_${problemIndex}_objective_${objectiveIndex}`
                      )
                    " :id="'treatment-plan-objectives-v1-wkioon-' + problemIndex + '-' + objectiveIndex"></b-icon-check-square-fill><b-icon-square v-else :id="'treatment-plan-objectives-v1-flbbyb-' + problemIndex + '-' + objectiveIndex"></b-icon-square>
                  {{ objective.shortTermMeasurableObjective }}
                </b-col>
                <b-col :id="'treatment-plan-objectives-v1-eaka4x-' + problemIndex + '-' + objectiveIndex">
                  {{ objective.interventions }}
                </b-col>
                <b-col :id="'treatment-plan-objectives-v1-tyas5l-' + problemIndex + '-' + objectiveIndex">
                  {{ objective.responsibleParties }}
                </b-col>
                <b-col :id="'treatment-plan-objectives-v1-sevqvd-' + problemIndex + '-' + objectiveIndex">
                  <div v-if="
                      objectiveSelected.includes(
                        `problem_${problemIndex}_objective_${objectiveIndex}`
                      )
                    " :id="'treatment-plan-objectives-v1-897lo4-' + problemIndex + '-' + objectiveIndex">
                    {{
                      objectiveDetails[
                        `problem_${problemIndex}_objective_${objectiveIndex}`
                      ]
                        ? objectiveDetails[
                            `problem_${problemIndex}_objective_${objectiveIndex}`
                          ]
                        : ""
                    }}
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-container>
      </div>
    </div>
  </div>

</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { formatDate, formatDateTimeMysql } from "../../../../helpers/date";
import formSubmitterServer from "../../../../server/formSubmitter";
import eFormServer from "../../../../server/eForm";
import TreatmentPlanObjectivesV1Properties from "./TreatmentPlanObjectivesV1Properties";
import { valueOrOther } from "../../../../helpers/formBuilder";
export default {
  name: "TreatmentPlanObjectivesV1",
  components: { TreatmentPlanObjectivesV1Properties },
  props: ["showType", "properties", "form", "id", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: ["hidden"],
      computedConditions: {},
      masterTreatmentPlanForm: null,
      masterTreatmentPlanDocumentOptions: []
    };
  },
  async mounted() {
    if (this.showType != "e-form") {
      this.computeConditions();
      if (this.showType == "form-submitter" || this.showType == "form-viewer")
        await this.fetchData();
      if (
        this.showType == "form-submitter" ||
        (this.showType == "e-form" && this.properties.eFormEditable)
      ) {
        this.getFormSubmitsOptions();
      }
    }
    this.$emit("mount-done");
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentMetadata"]),
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    ...mapActions("formBuilder", ["fetchFormBuilderForms"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    async fetchData() {
      await this.fetchFormBuilderForms({ category: "masterTreatmentPlan" });
      this.masterTreatmentPlanForm = await this.getFormBuilderFormById(
        this.masterTreatmentPlanFormId
      );
    },
    async getFormSubmitsOptions() {
      let submits = [];
      if (this.showType == "e-form") {
        /* submits = await eFormServer.querySubmits(
          this.$route.params.token,
          this.masterTreatmentPlanFormId,
          this.client.episodeOfCare.id
        ); */
      } else {
        submits = await formSubmitterServer.query(
          this.masterTreatmentPlanFormId,
          this.client.id,
          this.client.episodeOfCare.id
        );
      }

      this.masterTreatmentPlanDocumentOptions = submits.map(submit => ({
        value: submit.id,
        label: `${formatDate(submit.createdAt)} by ${
          submit.createdBy ? this.formatUser(submit.createdBy) : "-"
        }`,
        data: submit
      }));
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          Options: this.masterTreatmentPlanDocumentOptions
        }
      });
    },
    async reloadObjectives() {
      const submit = await this.getFormSubmitById(
        this.controlValue.document.id
      );
      const filteredSubmit = {
        id: submit.id,
        status: submit.status,
        versionId: submit.versionId,
        createdAt: submit.createdAt,
        createdBy: {
          id: submit.createdBy.id,
          fullName: this.formatUser(submit.createdBy),
          credentials: submit.createdBy.credentials
        },
        mode: submit.mode,
        results: submit.results,
        score: submit.score,
        effectiveDate: submit.effectiveDate
      };
      this.masterTreatmentPlanDocument = {
        value: filteredSubmit.id,
        label: `${formatDate(filteredSubmit.createdAt)} by ${
          filteredSubmit.createdBy
            ? this.formatUser(filteredSubmit.createdBy)
            : "-"
        }`,
        data: filteredSubmit
      };
      this.problemObjectives = await this.getProblems();
      this.objectiveSelected = [];
      this.objectiveDetails = {};
    },
    setObjectiveDetails(objective, newValue) {
      const newObjectiveDetails = { ...this.objectiveDetails };
      newObjectiveDetails[objective] = newValue;
      this.objectiveDetails = newObjectiveDetails;
    },
    async getProblems() {
      let treatmentPlanObjectivesMap = JSON.parse(
        this.masterTreatmentPlanForm.current.content.properties
          .treatmentPlanObjectivesMap
      );
      let results = this.masterTreatmentPlanDocument.data.results;

      let submits = [];
      if (this.showType == "e-form") {
        submits = await eFormServer.querySubmits(
          this.$route.params.token,
          this.masterTreatmentPlanFormId,
          this.client.episodeOfCare.id
        );
      } else {
        submits = await formSubmitterServer.query(
          this.masterTreatmentPlanFormId,
          this.client.id,
          this.client.episodeOfCare.id
        );
      }
      submits = submits.filter(
        submit =>
          submit.parentDocumentId == this.masterTreatmentPlanDocument.data.id
      );
      if (submits.length > 0) {
        submits.sort((s1, s2) =>
          formatDateTimeMysql(s2.effectiveDate).localeCompare(
            formatDateTimeMysql(s1.effectiveDate)
          )
        );
        results = submits[0].results;
        treatmentPlanObjectivesMap = JSON.parse(
          this.masterTreatmentPlanForm.current.content.properties
            .treatmentPlanObjectivesMap
        );
      }
      return results[treatmentPlanObjectivesMap.ProblemsCrudId].map(
        (problem, problemIndex) => {
          return {
            problem: valueOrOther(
              problem[treatmentPlanObjectivesMap.ProblemId + "_0"]
            ),
            identifiedProblem: valueOrOther(
              problem[treatmentPlanObjectivesMap.IdentifiedProblemId + "_0"]
            ),
            longTermGoal: valueOrOther(
              problem[treatmentPlanObjectivesMap.LongTermGoalId + "_0"]
            ),
            objectives: results[
              treatmentPlanObjectivesMap.ObjectivesCrudId +
                "_" +
                (problemIndex + 1)
            ]? results[
              treatmentPlanObjectivesMap.ObjectivesCrudId +
                "_" +
                (problemIndex + 1)
            ].map(objective => {
              return {
                shortTermMeasurableObjective: valueOrOther(
                  objective[
                    treatmentPlanObjectivesMap.ShortTermMeasurableObjectiveId +
                      "_" +
                      (problemIndex + 1) +
                      "_0"
                  ]
                ),
                interventions: objective[
                  treatmentPlanObjectivesMap.InterventionsId +
                    "_" +
                    (problemIndex + 1) +
                    "_0"
                ]
                  ? objective[
                      treatmentPlanObjectivesMap.InterventionsId +
                        "_" +
                        (problemIndex + 1) +
                        "_0"
                    ].value.join(", ")
                  : "",
                responsibleParties: objective[
                  treatmentPlanObjectivesMap.ResponsiblePartiesId +
                    "_" +
                    (problemIndex + 1) +
                    "_0"
                ]
                  ? objective[
                      treatmentPlanObjectivesMap.ResponsiblePartiesId +
                        "_" +
                        (problemIndex + 1) +
                        "_0"
                    ].value.join(", ")
                  : ""
              };
            }):[]
          };
        }
      );
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <div class="mb-0" style="${this.getComponentComputedProperties("style")}">
        <fieldset aria-describedby="" class="form-group">
          <legend style="font-size:14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" >Treatment Plan</legend>
          <div tabindex="-1" role="group" class="bv-no-focus-ring"><span style="font-size: 14px;">${
            this.masterTreatmentPlanDocument
              ? this.masterTreatmentPlanDocument.label
              : ""
          }</span>
          </div>
        </fieldset>
        ${
          this.masterTreatmentPlanForm && this.masterTreatmentPlanDocument
            ? `
          <div>
            <div class="d-flex justify-content-between align-items-center"><span style="font-size: 14px;">Objectives</span></div>
            <div class="mt-2 border container">
              ${this.problemObjectives
                .map(
                  (problem, problemIndex) => `
                <div>
                ${
                  problem.objectives.filter((objective, objectiveIndex) =>
                    this.objectiveSelected.includes(
                      `problem_${problemIndex}_objective_${objectiveIndex}`
                    )
                  ).length > 0
                    ? `
                  <div>
                    <div class="row py-2 bg-extra-light-gray" style="font-size: 13px;">
                      <div class="col">
                        <div><strong>Problem:</strong> ${problem.problem}</div>
                        <div><strong>Identified Problem:</strong> ${problem.identifiedProblem} </div>
                        <div><strong>Long-Term Goal:</strong> ${problem.longTermGoal} </div>
                      </div>
                    </div>
                    <div class="row border-bottom py-2" style="font-size: 14px;">
                      <div class="col"><strong>Objective</strong></div>
                      <div class="col"><strong>Interventions</strong></div>
                      <div class="col"><strong>Responsible Parties</strong></div>
                      <div class="col"><strong>Details</strong></div>
                    </div>
                  </div>
                  `
                    : ""
                }
                ${problem.objectives
                  .map(
                    (objective, objectiveIndex) => `
                  <div>
                    ${
                      this.objectiveSelected.includes(
                        `problem_${problemIndex}_objective_${objectiveIndex}`
                      )
                        ? `
                    <div class="row py-2 border-bottom" style="font-size: 12px;">
                      <div class="col">
                        ${
                          this.objectiveSelected.includes(
                            `problem_${problemIndex}_objective_${objectiveIndex}`
                          )
                            ? '<i class="fas fa-check-square text-primary"></i>'
                            : '<i class="far fa-square"></i>'
                        } ${objective.shortTermMeasurableObjective} </div>
                      <div class="col"> ${objective.interventions} </div>
                      <div class="col"> ${objective.responsibleParties} </div>
                      <div class="col">
                        ${
                          this.objectiveSelected.includes(
                            `problem_${problemIndex}_objective_${objectiveIndex}`
                          )
                            ? `
                        <div> ${
                          this.objectiveDetails[
                            `problem_${problemIndex}_objective_${objectiveIndex}`
                          ]
                            ? this.objectiveDetails[
                                `problem_${problemIndex}_objective_${objectiveIndex}`
                              ]
                            : ""
                        } </div>
                        `
                            : ""
                        }
                        
                      </div>
                    </div>
                    `
                        : ""
                    }
                    
                  </div>
                `
                  )
                  .join("")}
                
              </div>
              `
                )
                .join("")}
              
            </div>
          </div>
          `
            : ""
        }
        
      </div>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      client: state => state.form.client,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "getFormSubmitById"
    ]),
    ...mapState("formBuilder", {
      forms: state => state.list
    }),
    ...mapGetters("formBuilder", ["getFormBuilderFormById"]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    ...mapGetters("client", ["selectedLocation"]),
    masterTreatmentPlanFormId() {
      if (!this.selectedLocation) {
        return this.client.episodeOfCare.location.treatmentPlanFormId;
      }
      return this.selectedLocation.treatmentPlanFormId;
    },
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    masterTreatmentPlanDocument: {
      get() {
        let controlValue = {};
        if (this.results) controlValue = this.results[this.id];
        else controlValue = this.getFormSubmitterComponentValue(this.id);
        return controlValue
          ? {
              value: controlValue.document.id,
              label: `${formatDate(controlValue.document.createdAt)} by ${
                controlValue.document.createdBy
                  ? controlValue.document.createdBy.fullName
                  : "-"
              }`,
              data: controlValue.document
            }
          : null;
      },
      async set(newControlValue) {
        if (newControlValue) {
          const parsedControlValue = newControlValue.data;
          const filteredControlValue = {
            id: parsedControlValue.id,
            status: parsedControlValue.status,
            versionId: parsedControlValue.versionId,
            createdAt: parsedControlValue.createdAt,
            createdBy: {
              id: parsedControlValue.createdBy.id,
              fullName: this.formatUser(parsedControlValue.createdBy),
              credentials: parsedControlValue.createdBy.credentials
            },
            mode: parsedControlValue.mode,
            results: parsedControlValue.results,
            score: parsedControlValue.score,
            effectiveDate: parsedControlValue.effectiveDate
          };
          const newFomattedControlValue = {
            ...this.controlValue,
            document: filteredControlValue
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newFomattedControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          this.problemObjectives = await this.getProblems();
          this.objectiveSelected = [];
          this.objectiveDetails = {};
        }
      }
    },
    problemObjectives: {
      get() {
        let controlValue = {};
        if (this.results) controlValue = this.results[this.id];
        else controlValue = this.getFormSubmitterComponentValue(this.id);
        return controlValue && controlValue.problemObjectives
          ? controlValue.problemObjectives
          : [];
      },
      set(newControlValue) {
        if (newControlValue) {
          const newFomattedControlValue = {
            ...this.controlValue,
            problemObjectives: newControlValue
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newFomattedControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
        }
      }
    },
    objectiveSelected: {
      get() {
        let controlValue = {};
        if (this.results) controlValue = this.results[this.id];
        else controlValue = this.getFormSubmitterComponentValue(this.id);
        return controlValue && controlValue.selectedObjectives
          ? controlValue.selectedObjectives
          : [];
      },
      set(newControlValue) {
        if (newControlValue) {
          const newFomattedControlValue = {
            ...this.controlValue,
            selectedObjectives: newControlValue
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newFomattedControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
        }
      }
    },
    objectiveDetails: {
      get() {
        let controlValue = {};
        if (this.results) controlValue = this.results[this.id];
        else controlValue = this.getFormSubmitterComponentValue(this.id);
        return controlValue && controlValue.objectiveDetails
          ? controlValue.objectiveDetails
          : {};
      },
      set(newControlValue) {
        if (newControlValue) {
          const newFomattedControlValue = {
            ...this.controlValue,
            objectiveDetails: newControlValue
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newFomattedControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
        }
      }
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>

<style>
.treament-objective-checkbox label {
  padding-top: 3px;
}
</style>
